import { getFromDataPath, reduceDataPath, removeByPath } from "../../../utility";
import { ARSTActionContextmenuAction, ArsTableState } from "../interface";
import { isArsTableSubGroup } from "../typeguards/isArsTableSubGroup";
import { arst_checkSiblingSubgroups } from "./arst_checkSiblingSubgroups";

/**
 * Removes an operation from its parent group.
 *
 * @param state - Current ARS table state
 * @param action - Context-menu action describing the target operation cell
 * @returns Updated ARS table state
 */
export const arst_removeOperation = <T>(
  state: ArsTableState<T>,
  action: ARSTActionContextmenuAction<T>,
): ArsTableState<T> => {
  const parentDataPath = reduceDataPath(action.cellValue.dataPath, 2);
  const targetGroups = arst_checkSiblingSubgroups(
    state.bodyData,
    parentDataPath,
    state.settings.editorProps.isT,
  );
  const parentGroup = getFromDataPath(parentDataPath, state.bodyData, (obj) =>
    isArsTableSubGroup(obj, state.settings.editorProps.isT),
  );
  if (!parentGroup || !parentGroup.subGroups || !targetGroups) return state;

  const operationPathParts = action.cellValue.dataPath.split("/").filter(Boolean);
  const operationIndex = parseInt(operationPathParts[operationPathParts.length - 1], 10);
  if (Number.isNaN(operationIndex)) return state;

  const newBodyData = Object.keys(targetGroups).reduce((currentBodyData, groupDataPath) => {
    const groupInCurrentBody = getFromDataPath(groupDataPath, currentBodyData, (obj) =>
      isArsTableSubGroup(obj, state.settings.editorProps.isT),
    );
    const siblingCount = groupInCurrentBody?.subGroups?.length;
    if (!siblingCount || operationIndex >= siblingCount) return currentBodyData;

    return removeByPath(
      currentBodyData,
      `${groupDataPath}/subGroups/${operationIndex}`,
      siblingCount - 1,
    );
  }, state.bodyData);
  if (newBodyData === state.bodyData) return state;

  return {
    ...state,
    bodyData: newBodyData,
    changed: true,
  };
};
